import styled from 'styled-components';
import { colors, th } from 'style/theme';
import { motion } from 'framer-motion6';
import { ReactComponent as Pin } from 'products/global/assets/img/join-us/pin.svg';

export const VideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100% - 60px);
  background-size: cover;

  > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PlayButton = styled.div`
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100%;
  z-index: 10;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
`;

export const Image = styled.img`
  position: absolute;
  width: 100%;
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'calc(100% - 60px)')};
  background-image: ${({ photo }) => `url(${photo})`};
  background-size: cover;
  background-position: center;
`;

export const ContentWrapper = styled(motion.div)`
  width: 100%;
  height: 100%;
  top: 0;
  background-color: ${th('colors.indigo')};
  display: ${({ $isPlaying }) => ($isPlaying ? 'none' : 'block')};
  position: relative;

  ::after {
    pointer-events: none;
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: -99%;
    background-image: linear-gradient(
      180deg,
      rgba(86, 86, 194, 0) 0%,
      rgba(86, 86, 194, 0.15) 50%,
      ${colors.pickledBluewood} 100%
    );
  }
`;

export const Content = styled.div`
  width: 100%;
  height: calc(100% - 60px);
  padding: 4px 16px 16px 16px;
  display: block;
  line-height: 24px;
  font-size: 16px;
  overflow: scroll;
  scrollbar-width: 0px;
  -webkit-scrollbar-width: 0px;
`;

export const Footer = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: ${th('colors.indigo')};
  padding: 20px 24px;
  color: white;
  display: flex;
  justify-content: space-between;

  > h1 {
    font-size: 20px;
  }
`;

export const StyledPin = styled(Pin)`
  width: 8px;
  height: 14px;
`;

export const CardContainer = styled(motion.div)`
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  margin-right: ${({ marginRight }) => `${marginRight}px`};
  opacity: ${({ isActiveCard }) => (isActiveCard ? 1 : 0.7)};
  transition: 0.5s;
  transition-delay: 0.3;
  overflow: hidden;
  position: relative;
  width: 240px;
  height: 411px;
  z-index: 2;
`;
